import sanitize from '@utils/Sanitizer'

export const ACTIVE_FILTER_ID = 'active'
export const INACTIVE_FILTER_ID = 'inactive'

export const filterUsers = (users: UserResponse[], search: string, filters?: UserFilters) => {
  return users.filter((user) => {
    const validation: boolean[] = []

    const sanitizedSearch = sanitize(search)

    if (sanitizedSearch) {
      // Recherche textuelle sur : le prenom, le nom et l'email
      validation.push(
        sanitize(user.prenom).includes(sanitizedSearch) ||
          sanitize(user.nom).includes(sanitizedSearch) ||
          sanitize(user.email).includes(sanitizedSearch)
      )
    }

    if (!!filters) {
      // Sites
      if (filters.site.length > 0) {
        validation.push(!!filters.site.find((site) => user.siteIds.includes(site.id)))
      }

      // Manifestations
      if (filters.manifestation.length > 0) {
        validation.push(!!filters.manifestation.find((manif) => user.manifestationIds.includes(manif.id)))
      }

      // Type
      if (filters.typeUtilisateur.length > 0) {
        validation.push(!!filters.typeUtilisateur.find((type) => type.id === user.typeUtilisateur))
      }

      // Role
      if (filters.role.length > 0) {
        validation.push(!!filters.role.find((role) => user.roleIds.includes(role.id)))
      }

      // Status
      if (filters.status.length === 1) {
        if (filters.status.find((f) => f.id === INACTIVE_FILTER_ID)) {
          validation.push(!user.enabled)
        }
        if (filters.status.find((f) => f.id === ACTIVE_FILTER_ID)) {
          validation.push(user.enabled)
        }
      }

      // Prestataire
      if (filters.prestataire.length > 0) {
        validation.push(!!user.societeId && !!filters.prestataire.find((presta) => user.societeId === presta.id))
      }
    }
    return !!validation.every((e) => e)
  })
}

export const filterSocietes = (services: SocieteResponse[], search: string) => {
  return services.filter((service) => {
    const validation: boolean[] = []

    const sanitizedSearch = sanitize(search)

    if (sanitizedSearch) {
      // Recherche textuelle sur : le prenom, le nom et l'email
      validation.push(
        sanitize(service.codeSociete).includes(sanitizedSearch) ||
          sanitize(service.nameSociete).includes(sanitizedSearch) ||
          (!!service.contact && sanitize(service.contact).includes(sanitizedSearch)) ||
          (!!service.email && sanitize(service.email).includes(sanitizedSearch))
      )
    }

    return !!validation.every((e) => e)
  })
}

export const filterManifestations = (manifestations: ManifestationResponse[], search: string) => {
  return manifestations.filter((manif) => {
    const validation: boolean[] = []

    const sanitizedSearch = sanitize(search)

    if (sanitizedSearch) {
      // Recherche textuelle sur : le prenom, le nom et l'email
      validation.push(
        sanitize(manif.libelle).includes(sanitizedSearch) || sanitize(manif.codeManifestation).includes(sanitizedSearch)
      )
    }

    return !!validation.every((e) => e)
  })
}
